const PROPERTY_TAG_TYPES = {
  PROPERTY_GET_LIST: "PROPERTY_LIST",
  PROPERTY_CREATE: "PROPERTY_CREATE",
  PROPERTY_EDIT: "PROPERTY_EDIT",
  PROPERTY_DETAIL: "PROPERTY_DETAIL",
  PROPERTY_CHECK_CONFLICT: "PROPERTY_CHECK_CONFLICT",
  PROPERTY_CREATE_DRAFT: "PROPERTY_CREATE_DRAFT",
  PROPERTY_DETAIL_DRAFT: "PROPERTY_DETAIL_DRAFT",
  PROPERTY_TRUST: "PROPERTY_TRUST_DRAFT",
  PROPERTY_FEATURE: "PROPERTY_FEATURE",
  PROPERTY_LIST: "PROPERTY_LIST",
  PROPERTY_CHANGE_LOG: "PROPERTY_CHANGE_LOG",
  PROPERTY_UPLOAD_IMAGE: "PROPERTY_UPLOAD_IMAGE",
  PROPERTY_UPLOAD_DOCUMENT: "PROPERTY_UPLOAD_DOCUMENT"
};

export const PROPERTY_TAGS = Object.values(PROPERTY_TAG_TYPES);
export default PROPERTY_TAG_TYPES;
